module.exports = __webpack_public_path__ + "static/coney-zoom-24165ec146b5bf0bf4265e57084c9edf.jpg";